import { memo } from 'react';

import type { StaticDataChartWidgetData } from '@/features/_shared/widget-registry';
import { StaticChart } from '@/features/charts';
import { PageInformationContext } from '@/shared/lib/PageInformationContext';

export const StaticDataChart = memo(({ data }: { data: StaticDataChartWidgetData }) => (
  <PageInformationContext value={{ mainPageTitle: 'AI Chat' }}>
    <StaticChart
      applyWatermark
      chartConfig={data.chartConfig}
      label={data.title}
    />
  </PageInformationContext>
));

StaticDataChart.displayName = 'StaticDataChart';
